<template>
  <div class="account-login">
    <div class="login">
      <div class="bgBanner" id="bgBanner" :style="{'height': getHeight + 'px'}">
        <swiper :options="swiperOption" style="height: 100%;">
          <swiper-slide :key="index" v-for="(item, index) in swiperData">
            <img :src="item" alt>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="logo">
        <a href="/home/homepage">
          <div class="logoCon" v-if="config.isZhulogic">
            <img src="../../../images/login/logo2.png" alt>
          </div>
          <div class="logoCon logoConSpecail" v-else>
            <img src="../../../images/login/mtbbsLogo2.png" alt>
          </div>
        </a>
      </div>
    </div>
    <router-view class="m-box"></router-view>

    <!--<div class="bottomImg">-->
    <!--<div class="bascchreibung">-->
    <!--<div class="bascc" :key="index" v-if="purchaseData && purchaseData.length > 0" v-for="(item,index) in purchaseData">-->
    <!--<div class="img">-->
    <!--<img v-if="item.operMaterialFileList.length > 0 " :key="index" v-for="(imgitem, index) in item.operMaterialFileList" :src="imgBaseUrl + imgitem.key" alt="">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>
<style rel="stylesheet/scss" lang="scss">
.account-login .swiper-pagination-bullet-active {
  background-color: #308697;
}
</style>
<style>
.account-login {
  width: 100%;
  height: 100%;
  min-height: 700px;
  overflow: auto;
}

.login .logo {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 65px;
  left: 0;
  z-index: 3;
}

.login .logo .logoCon {
  display: inline-block;
  cursor: pointer;
  width: 323px;
  height: 160px;
}

.login .logo .logoConSpecail {
  width: 180px;
  height: 210px;
}

.login .logo .logoCon img {
  width: 100%;
}

.login .bgBanner {
  width: 100%;
  height: 100%;
  min-height: 700px;
}

.login img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

a:hover {
  color: inherit;
}

@keyframes sign-bg-move {
  0% {
    transform: translate(0);
  }
  to {
    transform: translateY(-250px);
  }
}

.m-box {
  position: absolute;
  height: 460px;
  width: 720px;
  top: 500px;
  left: 50%;
  margin-left: -360px;
  margin-top: -195px;
  border-radius: 4px;
  margin-bottom: 50px;
  z-index: 500;
}

@media screen and (max-width: 1800px) {
  .m-box {
    top: 400px;
    left: 50%;
  }

  .login .logo .logoCon {
    width: 290px;
    height: 146px;
  }

  .login .logo {
    top: 35px;
  }
  .login .logo .logoConSpecail {
    width: 135px;
    height: 158px;
  }
}
</style>
<style scoped>
html,
body {
  height: 100%;
}

#bgBanner .swiper-pagination {
  width: 280px;
  right: 0 !important;
  left: auto;
  bottom: 33px;
}

#bgBanner .swiper-pagination-bullet {
  background: #bfbfbf;
  opacity: 0.6;
  width: 10px;
  height: 10px;
  margin-right: 12px;
}

#bgBanner .swiper-pagination-bullet-active {
  display: inline-block;
  background: #308697;
  opacity: 1;
  border: 1px solid #fff !important;
}
.bascchreibung {
  width: 100%;
  padding: 100px 0;
  background: #fff;
}
.bascchreibung .bascc {
  display: inline-block;
  width: 100%;
  text-align: center;
}
.bascchreibung .changeBg {
  background: #f2f4f5;
}
.bascchreibung .bascc .title {
  display: inline-block;
  width: 100%;
  font-size: 54px;
  color: #353838;
}
.bascchreibung .bascc .img {
  display: inline-block;
  /*width: 1900px;*/
  text-align: center;
}
.bascchreibung .bascc .img img {
  display: inline-block;
}
</style>
<script>
import api from "../../../api";
import beginImgSrc from "../../../images/login/signinBg01.png";
import config from "../../../config/config";

export default {
  data() {
    return {
      config: config,
      imgBaseUrl: api.common.imgBaseUrl,
      redirect: this.$route.query.redirect || { name: "homePage" },
      beginImg: beginImgSrc,
      swiperOption: {
        notNextTick: true,
        autoplay: 3000,
        loop: true,
        speed: 800,
        effect: "fade",
        pagination: ".swiper-pagination",
        paginationClickable: true,
        observeParents: true
      },
      swiperData: [
        "http://zhulogic-formal.oss-cn-hangzhou.aliyuncs.com/designer_local_file/signinBg01.png",
        "http://zhulogic-formal.oss-cn-hangzhou.aliyuncs.com/designer_local_file/signinBg02.png",
        "http://zhulogic-formal.oss-cn-hangzhou.aliyuncs.com/designer_local_file/signinBg03.png"
      ],
      getHeight: 0,
      purchaseData: null
    };
  },
  methods: {
    goNext() {
      // 登录成功后跳转到其他网站
      if (this.redirect) {
        if (
          this.redirect.includes("http://") ||
          this.redirect.includes("https://")
        ) {
          window.location.href = this.redirect;
          return;
        }
      }
      if (this.redirect.includes("logout")) {
        this.$router.replace("/home/homepage");
      } else {
        this.$router.replace(this.redirect);
      }
    },
    getPurchase() {
      api.homePage.operMaterial().then(res => {
        this.purchaseData = res;
      });
    }
  },
  mounted() {
    this.getPurchase();
    this.getHeight = document.documentElement.clientHeight;
  }
};
</script>